import { GLServiceBase, ServiceRoute } from "commonui";
import { IFocusWordsChapterReportService } from "./interface";
import { ComponentResponseModel, UnitRangeQueryParamsModel } from "./model";

class FocusWordsChapterReportServiceClass extends GLServiceBase<any, any> implements IFocusWordsChapterReportService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/versions" };

	getComponentsByUnitRange(
		startUnitId: number,
		endUnitId: number,
		queryParams: UnitRangeQueryParamsModel
	): Promise<ComponentResponseModel[]> {
		return this.get(`contentchapterfocusword/${startUnitId}/${endUnitId}`, queryParams);
	}

	getFocusWordChapterReportData(data) {
		return this.create(`contentchapterfocusword`, data);
	}
}

export const FocusWordsChapterReportService: () => IFocusWordsChapterReportService = () =>
	new FocusWordsChapterReportServiceClass();
